import React, { Component } from 'react';
import './Products.css';

class Products extends Component {
  render() {
    return (
      <div className="products">
        hello world
      </div>
    );
  }
}

export default Products;
